/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 19.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import {VelocityComponent} from 'velocity-react';
import DivLoader from '../../../../DivLoader';
import ScrollArea from '../../../../ScrollArea';
import Translate from '../../../../Translate';

import {GetDevices} from '../../../../../actions/common/actions-common';
import {STATES} from '../../../../../containers/Player';

class MultiscreenDevices extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isShowed: false,
      devices: []
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({isShowed: newProps.show, devices: newProps.devices});

    if (newProps.show !== this.props.show && newProps.show) {
      this.props.GetDevices();
    }
  }

  __parseDevicePlatform(device) {

    switch (_get(device, 'platform.extid')) {
      case 'android':
        return 'android';

      case 'ottweb':
        return 'pc';

      case 'ios':
        return 'apple';

      case 'smart':
        return 'smart-tv';

      default:
        return 'none';
    }
  }

  _closeMe() {

    this.props.onClose();
  }

  _SendToAnotherDevice(device_id) {
    let params = {
      device_id: device_id,
      asset_id: this.props.asset && this.props.asset.id
    };

    //TODO: Remove this to Player. Because only player now his own state and position
    //Action.Share All players catch this event. And if that player not IDLE. He send to LH
    let plugin = _get(this.props, 'player.type');
    if (plugin === 'jw' && jwplayer('player') && jwplayer('player').getState() !== STATES.IDLE) {
      params.position = parseInt(jwplayer('player').getPosition(), 10);
    }

    lh.multiscreen.share(params, _get(this.props, 'asset.type') === 'channel')
      .then(() => {

        console.info(`Send ${this.props.asset && this.props.asset.id} to device done`);

        let plugin = _get(this.props, 'player.type');
        if (plugin === 'jw' && jwplayer('jw_player') && jwplayer('jw_player').getState() !== STATES.IDLE) {
          jwplayer('jw_player').stop();
        }

        this._closeMe();
      },(reason) => {
        console.error(`Send ${this.props.asset && this.props.asset.id} to device ${device_id} failed. ${reason}`);
      });
  }

  _renderDevices() {

    return this.state.devices.map((device) => {

      return (
        <div key={device.id} className="device">
          <a className="hover" onClick={this._SendToAnotherDevice.bind(this, device.id)}>
            <i className={`ic left ic-${this.__parseDevicePlatform(device)} ic-16px color-grey`}></i>
            {_get(device, 'title') || 'Unknown'}
          </a>
        </div>
      );
    });
  }

  render() {
    if (!Config.multiscreen_allowed) return (<noscript />);

    return (
      <VelocityComponent animation={{right: this.state.isShowed ? 0 : -270}} duration={500}>
        <div className="block-share bg-black devices-container">
          <div className="devices-back hover crow no-gutter" onClick={this._closeMe.bind(this)}>
            <i className="ic ic-chevron-right"></i>
          </div>
          <DivLoader loading={this.props.loading} />
          <div className="block-1" style={{float: 'right'}}>
            <div className="profile-r">
              <Translate content="profile.movie.select_screen" />
              <ScrollArea
                speed={0.8}
                className="devices mr mt"
                horizontal={false}
                smoothScrolling={true}>
                <div>
                  {this._renderDevices()}
                </div>
              </ScrollArea>
            </div>
          </div>
        </div>
      </VelocityComponent>
    );
  }
}

MultiscreenDevices.defaultProps = {
  loading: false,
  devices: [],
  show: false,
  asset: null
};

const mapStateToProps = ({common: {devices: {user_devices, loading}, player}}, ownProps) => {

  return {
    loading: loading,
    devices: user_devices.filter(function (device) {
      return _get(device, 'platform.extid') !== 'ottweb';
    }),
    player: player
  }
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({GetDevices}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiscreenDevices);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/MultiscreenDevices/multistcreen-devices.js